import * as React from 'react'
import { Form } from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import { FormattedMessage, useIntl } from 'react-intl'
import 'react-datepicker/dist/react-datepicker.css'
import { getLabel } from '../../../validators'
import PromptBtn from '../../buttons/PromptBtn/PromptBtn'
import { IDateTimePicker } from '../types'
import { TimeFormats } from '../../models/DateTime/types'
import { transformDate } from '../../models/DateTime/utils'
import { getDatePickerValues } from './getDatePickerValues'

const DateTimePicker: React.FC<IDateTimePicker> = ({
    name,
    state,
    setState,
    valueKey,
    messageKey,
    schema,
    timeSchema,
    timeIntervals,
    className,
    description,
    isColumn,
    minDate,
    maxDate,
    disabled,
    isRequired,
    timeFormat,
    isLabelHidden,
    errMsg,
    touched,
    setTouched,
    isParentDisabled,
}) => {
    const intl = useIntl()

    const onChange = (date: Date): void => {
        setTouched && setTouched({ ...touched, [name]: true })

        const formattedDate = transformDate(timeFormat, date, timeFormat)
        setState({ ...state, [valueKey]: formattedDate })
    }

    const handleBlur = () => {
        setTouched && setTouched({ ...touched, [name]: true })
    }

    const datepickerValues = getDatePickerValues(
        timeFormat as TimeFormats,
        state,
        valueKey
        // minDate,
        // maxDate,
    )

    const isInvalid = touched && touched[name] && errMsg

    if (!datepickerValues || datepickerValues.unsupported) {
        return (
            <div
                style={{ maxWidth: '600px' }}
                className={`${className} d-flex flex-1 mt-1 mb-1 align-items-center justify-content-between`}
            >
                <Form.Label
                    style={{ maxWidth: '30%' }}
                    className={`label-main mt-1 text-capital`}
                >
                    {getLabel(messageKey)}:{' '}
                </Form.Label>
                &nbsp;Unsupported datetime/time format
            </div>
        )
    }

    return (
        <Form.Group
            style={{ maxWidth: '600px' }}
            className={`${className} d-flex flex-1 mt-1 mb-1 align-items-start justify-content-between`}
        >
            {!isLabelHidden ? (
                <Form.Label
                    style={{ maxWidth: '30%' }}
                    className={`label-main mt-1 text-capital`}
                >
                    {getLabel(messageKey)}:{' '}
                    {isRequired && (
                        <span className="app-color-text label-required-mark">
                            *
                        </span>
                    )}
                </Form.Label>
            ) : null}
            <div
                style={{ width: isLabelHidden ? '100%' : '70%' }}
                className={`d-flex ${
                    !isColumn ? 'flex-1' : ''
                } p-relative flex-column`}
            >
                <div className="d-flex justify-content-between w-100">
                    <DatePicker
                        timeCaption="time"
                        onChange={onChange}
                        onBlur={handleBlur}
                        locale={intl.locale}
                        disabled={disabled ?? false}
                        minDate={datepickerValues.minDate}
                        maxDate={datepickerValues.maxDate}
                        minTime={datepickerValues.minTime}
                        maxTime={datepickerValues.maxTime}
                        timeIntervals={timeIntervals || 60}
                        selected={datepickerValues.selected}
                        dateFormat={datepickerValues.dateFormat}
                        timeFormat={datepickerValues.timeFormat}
                        showTimeSelect={timeFormat !== TimeFormats.DATE}
                        placeholderText={datepickerValues.placeholderText}
                        showTimeSelectOnly={datepickerValues.showTimeSelectOnly}
                        className={`form-control ${
                            isInvalid && !isParentDisabled && 'is-invalid'
                        }`}
                    />
                    {description && (
                        <PromptBtn
                            className="mt-1 input-tooltip"
                            prompt={description ?? ''}
                        />
                    )}
                </div>
                {!isParentDisabled && isInvalid && (
                    <p
                        style={{
                            color: '#dc3545',
                            marginBottom: '0',
                            fontSize: '0.7rem',
                        }}
                    >
                        <FormattedMessage id={errMsg?.message} />
                    </p>
                )}
            </div>
        </Form.Group>
    )
}

export default DateTimePicker
